<template>
	<el-scrollbar style="height: 100%">
		<div>
			<div class="crumbs">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/monitorCAAList' }">
						<i class="el-icon-video-camera"></i> 视频管理
					</el-breadcrumb-item>
					<el-breadcrumb-item>更新视频信息</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="container">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'视频ID'" prop="caaMSID">
								<el-input v-model="ruleForm.caaMSID" :placeholder="'请输入视频ID'" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">
							<el-form-item :label="'所属幼儿园'" prop="caaSAAI">
								<el-select v-model="ruleForm.caaSAAI" :disabled="true" clearable filterable :placeholder="'请选择幼儿园'" class="handle-select mr10" @change="SAAIchange">
									<el-option v-for="item in ruleForm.optionsSAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'视频类别'" prop="cflSTID">
								<el-select v-model="ruleForm.cflSTID" clearable :placeholder="'请选择类别'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsSTID" :key="item.CFLSTID" :label="item.CFLNAME" :value="item.CFLSTID">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'视频名称'" prop="caaNAME">
								<el-input v-model="ruleForm.caaNAME" :placeholder="'请输入视频名称'" maxlength="20"></el-input>
								<div><span style=" width:250%; height: 10px; padding-top: 10px; font-size: 14px;color: #999999;">
										（例：操场）
									</span></div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item :label="'当前状态'" prop="caaNOST" v-show="false">
								<el-select v-model="ruleForm.caaNOST" clearable :placeholder="'请选择状态'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsNOST" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'通道号'" prop="caaCHAL">
								<el-input v-model="ruleForm.caaCHAL" :placeholder="'请输入通道号'" maxlength="2"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item :label="'RTSP视频源地址'" prop="caaRTSP">
								<el-input v-model="ruleForm.caaRTSP" :placeholder="'请输入RTSP视频源地址'" maxlength="100"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<!-- :placeholder="'RTMP推流地址'" -->
							<el-form-item :label="'RTMP推流地址'" prop="caaRTMP">
								<el-input v-model="ruleForm.caaRTMP" :disabled="true" ></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- 视频开放时间段模板ID -->
					<el-row>
						<el-form-item :label="'视频开放时间段模板'" prop="scaMSID">
							<el-select v-model="ruleForm.scaMSID" clearable :placeholder="'请选择时间段模板'" class="handle-select mr10">
								<el-option v-for="item in ruleForm.optionsSCA" :key="item.SCAMSID" :label="item.SCANAME" :value="item.SCAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-row>
					<el-row>
						<el-col :span="23">
							<el-form-item :label="'删除状态'" prop="caaDELF">
								<el-select v-model="ruleForm.caaDELF" clearable :placeholder="'请选择删除状态'" class="handle-select mr10">
									<el-option v-for="item in ruleForm.optionsDELF" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
									</el-option>
								</el-select>
								<div>
									<span style=" width:250%; height: 10px; padding-top: 10px; font-size: 14px;color: #999999;">
										修改此项后请在onvif启用或禁用对应的RTMP推流地址
									</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<div class="submit">
								<el-form-item>
									<el-button @click="goBack()" class="goback">返回</el-button>
									<el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoading">提交</el-button>
									
								</el-form-item>
							</div>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
	</el-scrollbar>
</template>

<script>
	export default {
		name: 'editMonitorCAA',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入视频名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkCAANAME(value);
					if (this.isRepeatNAME == true) {
						callback(new Error('视频名称重复'));
					} else {
						callback();
					}
				}
			}
			
			//验证RTSP
			const validateRTSP = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入RTSP视频源地址'))
				} else {
					this.checkCAARTSP(value);
					if (this.isRepeatRTSP == true) {
						callback(new Error('RTSP视频源地址重复'));
					} else {
						callback();
					}
				}
			}
			
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				caaChangeData: {},

				startTime: '07:00',
				isRepeatNAME: false,
				isRepeatRTSP:false,
				delfSHow:false,
				btnLoading:false,
				ruleForm: {
					caaSAAI: '',
					optionsSAAI: [],
					
					caaNAME: '',
					cflSTID: '',
					optionsSTID: [],
					
					caaNOST: '',
					optionsNOST: [],
					
					caaCHAL:'',//通道号
					caaRTSP:'',
					caaRTMP:'',
					
					caaDELF: '',
					scaMSID: '',
					optionsSCA: [] //时间段模板
				},
				rules: {
					caaNAME: [{
						required: true,
						//message: '请输入视频名称', //'请输入社名称'
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					caaSAAI: [{
						required: true,
						message: '请选择幼儿园',
						trigger: ['blur', 'change']
					}],
					cflSTID: [{
						required: true,
						message: '请选择类别',
						trigger: ['blur', 'change']
					}],
					caaNOST: [{
						required: true,
						message: '请选择状态',
						trigger: ['blur', 'change']
					}],
					caaCHAL: [{
						required: true,
						message: '请输入通道号',
						trigger: ['blur', 'change']
					}],
					caaRTSP: [{
						required: true,
						trigger: ['blur', 'change'],
						validator: validateRTSP
					}],
					caaDELF: [{
						required: true,
						message: '请选择删除状态',
						trigger: ['blur', 'change']
					}],
					scaMSID: [{
						required: true,
						message: '请选择视频开放时间段模板',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editMonitorCAA") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.caaMSID = this.$route.query.CAAMSID;
			this.getSAAI(); //幼儿园
			this.getNOST(); //状态
			this.getSTID(); //状态
			this.getDELF(); //获取删除状态
			this.getData(this.caaMSID);
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			dummyCreated() {
				this.caaMSID = this.$route.query.CAAMSID;
				this.getSAAI(); //幼儿园
				this.getNOST(); //状态
				this.getSTID(); //状态
				this.getDELF(); //获取删除状态
				this.getData(this.caaMSID);
			},
			//获取删除信息
			getDELF() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10005 //删除 10005
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsDELF = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取删除状态请求失败', //请求失败
							type: 'error'
						});
					});
			},
			//获取状态信息
			getNOST() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10007 //状态
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsNOST = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取当前状态请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取视频开放时间段模板信息
			getSCAMSID(saai) {
				const self_shop = this;
				
				var postUrl = 'WCF/WEB/svcSCA.svc/Get_CAASCA_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAI: saai //所属幼儿园
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					
					if (resCount > 0) {
						this.ruleForm.optionsSCA = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
					
				});
			},
			//获取类别信息
			getSTID(saai) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCFL.svc/Get_CFL_BYSAAI';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sSAAI: saai 
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSTID = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取类别请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取幼儿园信息
			getSAAI() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon //web侧 登录邮箱
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSAAI = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取幼儿园请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取视频信息
			getData(caaMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/GET_CAA_BYID';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon,
							sMSID: caaMSID 
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
								self.ruleForm.caaMSID = response.data.KKDT[0].CAAMSID;
								self.ruleForm.caaSAAI = response.data.KKDT[0].CAASAAI;
								self.ruleForm.cflSTID = response.data.KKDT[0].CFLSTID;
								self.ruleForm.caaNAME = response.data.KKDT[0].CAANAME;
								self.ruleForm.caaNOST = response.data.KKDT[0].CAANOST;
								
								self.ruleForm.caaCHAL = response.data.KKDT[0].CAACHAL;
								self.ruleForm.caaRTSP = response.data.KKDT[0].CAARTSP;
								self.ruleForm.caaRTMP = response.data.KKDT[0].CAARTMP;
								
								self.ruleForm.caaDELF = response.data.KKDT[0].CAADELF;
								// if(self.ruleForm.caaDELF == '1'){
								// 	this.delfSHow = true;
								// }
								self.ruleForm.scaMSID = response.data.KKDT[0].CAASCAI;
								
								this.caaChangeData = response.data.KKDT[0];
								this.getSTID(response.data.KKDT[0].CAASAAI);
								this.getSCAMSID(response.data.KKDT[0].CAASAAI);
							} else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} else {
							this.$message({
								message: '获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//验证此幼儿园下，视频名称是否重复
			checkCAANAME(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/CHECK_CAA_NAME';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sSAAID: self_shop.ruleForm.caaSAAI,
							sCAAID: self_shop.ruleForm.caaMSID,
							sCAANM: value
						}
					)
					.then((response) => {
						//请求成功返回的数据
						//console.log("aaaaa:" + response.data.KKSTR);
						if (response.data.KKSTR == "Y") {
							this.isRepeatNAME = true;
						} else {
							this.isRepeatNAME = false;
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//验证RTSP是否已存在
			checkCAARTSP(value) {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcCAA.svc/CHECK_CAA_RTSP';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sCAAID: self_shop.ruleForm.caaMSID,
						sRTSP: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeatRTSP = true;
					} else {
						this.isRepeatRTSP = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '验证RTSP请求失败',
						type: 'error'
					});
				});
			},
			//保存视频信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.btnLoading = true;

						const self = this;

						var valSAAI;
						if (self.ruleForm.caaSAAI == "undefined") {
							valSAAI = '';
						} else {
							valSAAI = self.ruleForm.caaSAAI;
						}
						
						var valSCAI;
						if (self.ruleForm.scaMSID == "undefined") {
							valSCAI = '';
						} else {
							valSCAI = self.ruleForm.scaMSID;
						}
						
						//console.log("---valSCAI--"+valSCAI)
						
						var valDELF;
						if (self.ruleForm.caaDELF == "undefined") {
							valDELF = '';
						} else {
							valDELF = self.ruleForm.caaDELF;
						}
						
						var valSTID;
						if (self.ruleForm.cflSTID == "undefined") {
							valSTID = '';
						} else {
							valSTID = self.ruleForm.cflSTID;
						}
						
						var valNOST;
						if (self.ruleForm.caaNOST == "undefined") {
							valNOST = '';
						} else {
							valNOST = self.ruleForm.caaNOST;
						}
						
						var valCHAL;
						if (self.ruleForm.caaCHAL == "undefined") {
							valCHAL = '';
						} else {
							valCHAL = self.ruleForm.caaCHAL;
						}
						
						var valRTSP;
						if (self.ruleForm.caaRTSP == "undefined") {
							valRTSP = '';
						} else {
							valRTSP = self.ruleForm.caaRTSP;
						}
						
						let caaFlag = false;
						if (this.caaChangeData.CAANAME != this.ruleForm.caaNAME) {
							caaFlag = true;
						}
						
						if (this.caaChangeData.CAASAAI != valSAAI) {
							caaFlag = true;
						}
						if (this.caaChangeData.CAANOST != valNOST) {
							caaFlag = true;
						}
						if (this.caaChangeData.CAACHAL != valCHAL) {
							caaFlag = true;
						}
						if (this.caaChangeData.CAARTSP != valRTSP) {
							caaFlag = true;
						}
						if (this.caaChangeData.CFLSTID != valSTID) {
							caaFlag = true;
						}
						if (this.caaChangeData.CAADELF != valDELF) {
							caaFlag = true;
						}
						if (this.caaChangeData.CAASCAI != valSCAI) {
							caaFlag = true;
						}
						
						var postUrl = 'WCF/WEB/svcCAA.svc/UPD_CAA_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sMSID: self.caaMSID, //宝宝ID
									sCAASAAI: valSAAI,
									sCAASTID: valSTID,
									sCAANAME: self.ruleForm.caaNAME,
									sCAANOST: valNOST,
									sCAACHAL: valCHAL,
									sCAARTSP: valRTSP,
									sCAADELF: valDELF,
									sCAASCAI: valSCAI
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '视频信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('视频信息更新成功'); // 编辑成功
										this.$router.push('/monitorCAAList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editMonitorCAA") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新视频信息失败', //请求失败
										type: 'error'
									});
								}
								this.btnLoading = false;
							})
							.catch((error) => {
								this.btnLoading = false;
								this.$message({
									message: '请求更新视频信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.btnLoading = false;
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 幼儿园选择事件
			SAAIchange() {
				if (typeof(this.ruleForm.caaSAAI) !== 'undefined') {
					
					this.getSTID(this.ruleForm.caaSAAI);
					this.getSCAMSID(this.ruleForm.caaSAAI);
					
					this.ruleForm.scaMSID = '';
					this.ruleForm.cflSTID = '';
				}
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editMonitorCAA") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.el-dialog__footer {
		text-align: center;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}


	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 5px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}
</style>
